import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loading: false,
    addressListingData: [],
    shippingAddresses: [],
    billingAddresses: []
};
export function addressReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.GET_BRAND_ADDRESS_ITEM_SUCCESS:
            return { ...state, loading: false, addressItem: action.payload.result.address };
        // case adminConstants.DELETE_BRAND_ADDRESS_SUCCESS:
        //     return {
        //         ...state,
        //         addressListingData: [
        //             ...state.addressListingData.filter(
        //                 item => item.id !== action.payload
        //             )
        //         ]
        //     };
        case adminConstants.PAGINATION_BRAND_ADDRESSES_SUCCESS:
            return {
                ...state,
                addressListingData: action.payload.result.addresses.data,
                pages: action.payload.result.addresses.last_page,
                loading: false,
                current_page: action.payload.result.addresses.current_page
            };
        case adminConstants.GET_SHIPPING_ADDRESSES_SUCCESS:
            return {
                ...state,
                shippingAddresses: action.payload
            };
        case adminConstants.GET_BILLING_ADDRESSES_SUCCESS:
            return {
                ...state,
                billingAddresses: action.payload
            };
        case adminConstants.DELETE_CUSTOMER_BRAND_SUCCESS:
            return {
                ...state,
                customerBrandPermissions: [
                    ...state.customerBrandPermissions.filter(
                        item => item.id !== action.payload
                    )
                ]
            };
        case adminConstants.STORE_CUSTOMER_BRAND_SUCCESS:
            return {
                ...state,
                customerBrandPermissions: [
                    ...state.customerBrandPermissions,
                    action.payload.result.data
                ]
            };
        case adminConstants.GET_CUSTOMER_BRANDS_SUCCESS:
            return {
                ...state,
                customerBrandPermissions: action.payload
            };
        case adminConstants.GET_BRAND_DATA_FOR_CUSTOMER_SUCCESS:
            return {
                ...state,
                brands: action.payload
            };
        case adminConstants.GET_BRANDS_LIST_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRANDS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.brands.current_page,
                pages: action.payload.result.brands.last_page,
                brands: action.payload.result.brands.data
            };
        case adminConstants.GET_BRANDS_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                brand: action.payload.result.brand
            };
        case adminConstants.STORE_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_ORDER_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_ORDER_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_ORDER_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.GET_BRAND_DATA_BYKEY_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_DATA_BYKEY_SUCCESS:
            return {
                ...state,
                loading: false,
                brand: action.payload.result.brand
            };
        case adminConstants.GET_BRAND_DATA_BYKEY_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_PRODUCT_DATA_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_PRODUCT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                brandProductDatacurrent_page:
                    action.payload.result.product_data.current_page,
                brandProductDatapages:
                    action.payload.result.product_data.last_page,
                brandProductData: action.payload.result.product_data.data
            };
        case adminConstants.GET_BRAND_PRODUCT_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.STORE_BRAND_DATA_DEFINITION_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_DATA_DEFINITION_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_DATA_DEFINITION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_DATA_DEFINITIONS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_DATA_DEFINITIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.brands.current_page,
                pages: action.payload.result.brands.last_page,
                brandDataDefinitionData: action.payload.result.brands.data
            };
        case adminConstants.GET_BRAND_DATA_DEFINITIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.EDIT_BRAND_DATA_DEFINITION_REQUEST:
            return { ...state };
        case adminConstants.EDIT_BRAND_DATA_DEFINITION_SUCCESS:
            return {
                editDataDefinition: action.payload.result.data_definition
            };
        case adminConstants.EDIT_BRAND_DATA_DEFINITION_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.PAGINATION_TAG_LAYOUTS_SUCCESS:
            return {
                ...state,
                taglayoutsData: action.payload.data,
                pages: action.payload.last_page,
                loading: false,
                current_page: action.payload.current_page
            };

        case adminConstants.GET_TAG_LAYOUT_SUCCESS:
            return { ...state, taglayout: action.payload };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AddressReducer.jsx